// Clínicas de la organización con la que se ha entrado. Se cargan de orgs/{org}/clinicas al iniciar sesión
// (App.jsx → fijarClinicas) y se editan en «Mi clínica». La lista es siempre la misma (se rellena en su sitio),
// así que el código que hace CLINICAS.find/map sigue funcionando.
import { infoOrg } from './org';

export const CLINICAS = [];
export function fijarClinicas(lista) {
  CLINICAS.splice(0, CLINICAS.length, ...lista);
}

export const GRUPO = 'grupo';

export const nombreClinica = (id) =>
  id === GRUPO ? infoOrg().nombre || 'Todas' : CLINICAS.find((c) => c.id === id)?.nombre ?? id;

// Reconoce una clínica por un texto (nombre de hoja de Excel, columna «Centro», etc.): nombre exacto, contenido o una palabra propia
const sinTildes = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
export function clinicaPorTexto(t) {
  const x = sinTildes(t);
  if (!x) return null;
  const nom = (c) => [c.nombre, c.marca, ...(c.alias || [])].map(sinTildes).filter(Boolean);
  return (CLINICAS.find((c) => nom(c).includes(x))
    || CLINICAS.find((c) => nom(c).some((n) => x.includes(n) || n.includes(x)))
    || CLINICAS.find((c) => nom(c).some((n) => n.split(' ').some((w) => w.length >= 4 && x.split(' ').includes(w)))))?.id || null;
}
